(function() {
  'use strict';
  angular.module('forgotPassword',[
    'ngResource',
    'dnErrorDisplay',
    'common',
    'ui.bootstrap',
    'registration'
	]);
})();
